<template>
  <SheetContainer title="插入静音" desc="光标处点击，设置前后静音时长">
    <ul class="sheet-list">
      <li
        v-for="(item, index) in muteObjs"
        :key="item.id"
        class="sheet-item"
        :class="{ checked: selectedValue === item.value }"
        @click="onSelectClick(index)"
      >
        <span>{{ item.name }}</span>
      </li>
      <li
        class="sheet-item custom"
        :class="{ customized }"
        @click="onCustomClick"
      >
        <span>{{ customText }}</span>
      </li>
      <li
        class="sheet-item remove"
        :class="{ removable }"
        @click="onRemoveClick"
      >
        <span>移除</span>
      </li>
    </ul>
    <InputModal
      title="自定义静音时长"
      type="number"
      placeholder="请输入5000ms以内静音"
      :visible.sync="customInputVisible"
      @confirm="onCustomInput"
    />
  </SheetContainer>
</template>
<script>
import { muteTimeList } from "@/views/index/config/muteList";
import InputModal from "@/components/input-modal/input-modal.vue";
import SheetContainer from "../sheet-container/sheet-container.vue";
import { toast } from "@/utils/util";
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  components: {
    SheetContainer,
    InputModal,
  },
  data() {
    return {
      muteObjs: muteTimeList.map((item, index) => {
        return {
          ...item,
          id: index + 1,
        };
      }), // 预置的静音选项
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
      customInputVisible: false, // 自定义弹窗是否显示
    };
  },
  computed: {
    removable() {
      return this.selectedValue;
    },
    customized() {
      return (
        this.selectedValue &&
        !this.muteObjs.some((mute) => mute.value === this.selectedValue)
      );
    },
    customText() {
      return this.customized ? this.selectedValue : "+自定义";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selectedValue = this.value;
      },
    },
  },
  methods: {
    // 校验选中是否合法
    isValid() {
      const $editor = this.$parent;
      if (
        $editor.hasEffectRange(
          this.selection.range || this.selection.caret,
          "aliasChange"
        )
      ) {
        toast("别名暂不支持与当前功能组合使用");
        return false;
      }

      // 多发音人特效支持检查
      const speakerNotSupport = $editor.isRangeSpeakerNotSupportEffect(
        this.selection.range,
        "mute"
      );
      if (speakerNotSupport) {
        toast(`${speakerNotSupport.name.split("|")[0]}暂不支持插入静音`);
        return false;
      }
      return true;
    },
    //插入/修改静音
    onSelectClick(index) {
      if (!this.isValid()) return;
      const seletedMute = this.muteObjs[index];
      this.updateValue(seletedMute.value);
    },
    // 删除静音
    onRemoveClick() {
      this.updateValue("");
    },
    // 打开自定义弹窗
    onCustomClick() {
      if (!this.isValid()) return;
      this.customInputVisible = true;
    },
    // 自定义输入
    onCustomInput(value) {
      if (!/^[1-9][0-9]*$/.test(value)) {
        toast("静音时长必须是正整数");
        return;
      }
      if (value > 5000) {
        toast("静音时长不能超过5000ms");
        return;
      }
      this.updateValue(value);
    },
    // 更新静音值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);
        if (newValue) {
          customCollectEvent("editor_jingyin", {
            time: +newValue,
          });
        }
      }
    },
  },
};
</script>